var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ds-table',{attrs:{"data":_vm.popupData.data,"heads":_vm.heads,"paginate":false,"spacer":"","max-items":_vm.popupData.data.length}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }